import React from "react";
import styles from "./styles.module.scss";
import InvitationsList from "app/components/InvitationsList";
import no_invitations from "app/images/no_invitations.png";
import { useTranslation } from "react-i18next";

const IncomingInvitations = () => {
  const { t } = useTranslation();

  const NullData = () => {
    return (
      <div className={styles.empty_container}>
        <img src={no_invitations} alt="no invites" />
        <div className={styles.empty_text_wrapper}>
          <p className={styles.empty_text}>{t("No invitations")}</p>
          <p className={styles.emtpy_text_description}>
            {t("You don’t have any invitations yet")}
          </p>
        </div>
      </div>
    );
  };
  return (
    <InvitationsList
      className={styles.container}
      nullResultChildren={<NullData />}
    />
  );
};

export default IncomingInvitations;
